import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { PdpSharedDetail } from './PdpSharedDetail';
import { PdpSharedConditionModalLoader } from '../PdpSharedModals/PdpSharedConditionModal/PdpSharedConditionModalLoader';
import * as tracking from 'dibs-tracking';

const openConditionModal = setModalOpen => {
    tracking.trackEvent({
        category: 'product',
        action: 'view condition descriptions clicked',
    });

    setModalOpen(true);
};

export const PdpSharedDetailCondition = props => {
    const [modalOpen, setModalOpen] = useState(false);

    const { detailValues, currency, delimiter, itemId, relay } = props;
    return (
        <>
            <PdpSharedDetail
                detailValues={detailValues}
                onClickMap={{
                    condition: {
                        clickFn: () => openConditionModal(setModalOpen),
                        dataTn: 'open-condition-modal',
                    },
                }}
                currency={currency}
                delimiter={delimiter}
            />
            <div>
                <div>
                    <PdpSharedConditionModalLoader
                        isOpen={modalOpen}
                        onClose={() => setModalOpen(false)}
                        environment={relay.environment}
                        itemId={itemId}
                    />
                </div>
            </div>
        </>
    );
};

PdpSharedDetailCondition.propTypes = {
    detailValues: PropTypes.array,
    delimiter: PropTypes.string,
    currency: PropTypes.string,
    relay: PropTypes.object.isRequired,
    itemId: PropTypes.string.isRequired,
};
